// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDF38cSNzvpjk1OQQ1z8nFWgIE5ZGTf5B4",
    authDomain: "keys-db.firebaseapp.com",
    databaseURL: "https://keys-db.firebaseio.com",
    projectId: "keys-db",
    storageBucket: "keys-db.appspot.com",
    messagingSenderId: "817437099485",
    appId: "1:817437099485:web:436e5bf0da2bc70bede234",
    measurementId: "G-3VRCYLDK1C"
};

export default firebaseConfig;

